import _stimulus from "stimulus";

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

function t(r, e) {
  return (t = Object.setPrototypeOf || function (t, r) {
    return t.__proto__ = r, t;
  })(r, e);
}

var r = function (r) {
  var e, o, n;

  function a() {
    return r.apply(this || _global, arguments) || this || _global;
  }

  return o = r, (e = a).prototype = Object.create(o.prototype), e.prototype.constructor = e, t(e, o), a.prototype.connect = function () {
    var t = new IntersectionObserver(function (t, r) {
      t.forEach(function (t) {
        t.target.src = t.target.dataset.src, r.unobserve(t.target);
      });
    }, {
      root: (this || _global).root,
      rootMargin: (this || _global).rootMargin,
      threshold: (this || _global).threshold
    });

    (this || _global).imageTargets.forEach(function (r) {
      return t.observe(r);
    });
  }, (n = [{
    key: "rootMargin",
    get: function () {
      return (this || _global).hasRootMarginValue ? (this || _global).rootMarginValue : "0px";
    }
  }, {
    key: "root",
    get: function () {
      return (this || _global).hasRootTarget ? (this || _global).rootTarget : null;
    }
  }, {
    key: "threshold",
    get: function () {
      return (this || _global).hasThresHoldValue ? (this || _global).thresholdValue : [0];
    }
  }]) && function (t, r) {
    for (var e = 0; e < r.length; e++) {
      var o = r[e];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }(a.prototype, n), a;
}(_stimulus.Controller);

r.targets = ["image", "root"], r.values = {
  rootMargin: String,
  threshold: Array
}, exports = r; //# sourceMappingURL=stimulus-lazy-loader.js.map

export default exports;